import { t } from '@lingui/macro';
import { ApplicationTable } from 'applicationTable/ApplicationTable';
import { ApplicationTableProvider } from 'applicationTable/ApplicationTable.context';
import { ApplicationTableHeader } from 'applicationTable/applicationTableHeader/ApplicationTableHeader';
import { Dashboard } from 'components/Dashboard/Dashboard';
import { DashboardProvider } from 'components/Dashboard/Dashboard.context';
import { ApplicationTableStateProvider } from 'contexts/ApplicationTableStateContext/ApplicationTableStateContext';
import { getCookie } from 'utils/cookieHelper';
import { useTrackingIdentify } from 'utils/tracking/tracking.hooks';
import { BaseLayout } from '../components/Layout/BaseLayout/BaseLayout';

import styles from './index.module.css';

export const HomePage = () => {
  useTrackingIdentify();
  const showNewDashboard = getCookie('showNewDashboard');

  if (showNewDashboard) {
    return (
      <BaseLayout
        pageTitle={t`Dashboard | Introducer Portal`}
        className={styles.dashboardLayout}
        showDEFooter
      >
        <DashboardProvider>
          <Dashboard />
        </DashboardProvider>
      </BaseLayout>
    );
  }

  return (
    <ApplicationTableStateProvider>
      <ApplicationTableProvider>
        <BaseLayout
          pageTitle={t`Dashboard | Introducer Portal`}
          className={styles.dashboardLayout}
          showDEFooter
        >
          <ApplicationTableHeader />
          <ApplicationTable />
        </BaseLayout>
      </ApplicationTableProvider>
    </ApplicationTableStateProvider>
  );
};
